import { isCropRowFailed, isCropRowSuccess } from './imageCropRowStatus';

export { isCropRowFailed, isCropRowSuccess };

/**
 * 根据裁剪记录计算任务进度（未处理的图片不计入失败）
 */
export function computeCropTaskProgress(cropImages, imageIds) {
  const ids = [...new Set((imageIds || []).filter(Boolean).map(String))];
  const total = ids.length;
  if (total === 0) {
    return { total: 0, successCount: 0, failedCount: 0, pendingCount: 0, status: 'failed' };
  }

  const map = new Map();
  (cropImages || []).forEach((row) => {
    if (row?.imageId != null) map.set(String(row.imageId), row);
  });

  let successCount = 0;
  let failedCount = 0;
  for (const id of ids) {
    const row = map.get(id);
    if (isCropRowSuccess(row)) successCount += 1;
    else if (isCropRowFailed(row)) failedCount += 1;
  }
  const pendingCount = total - successCount - failedCount;

  let status = 'processing';
  if (pendingCount <= 0) {
    if (successCount > 0 && failedCount > 0) status = 'partial';
    else if (failedCount >= total) status = 'failed';
    else status = 'success';
  }

  return { total, successCount, failedCount, pendingCount, status };
}
